/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import { ActionType } from 'cio/models/action';
import actionInfo from 'cio/utils/action-info';
import { Channel } from 'cio/utils/metrics/common';

interface ChannelsLabelArgs {
  channels: Channel[];
}

export default class ChannelsLabel extends Component<ChannelsLabelArgs> {
  get channelNames() {
    return this.args.channels.map((c) => actionInfo(`${c}_action` as ActionType).name);
  }

  get tooltipContent() {
    return htmlSafe(this.channelNames.map((n) => `<p class="mb-0">${n}</p>`).join(''));
  }
}
